import ExpertiseChat1 from "./v1/ExpertiseChatV1.mjs";
import ExpertiseChat2 from "./v2/ExpertiseChatV2.mjs";
const ExpertiseChatV1 = ExpertiseChat1;
const ExpertiseChatV2 = ExpertiseChat2;
export {
  ExpertiseChatV1,
  ExpertiseChatV2
};
//# sourceMappingURL=index.mjs.map
